export function PageHeader({ title, subtitle, children, testid }) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between mb-8 animate-fade-up" data-testid={testid}>
      <div>
        <p className="text-xs tracking-[0.2em] uppercase text-primary">Gestionale</p>
        <h1 className="font-dash text-2xl sm:text-3xl font-semibold mt-1">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-1 text-sm">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2 flex-wrap">{children}</div>
    </div>
  );
}
